<template>
 
<v-dialog v-model="yardimciIslemKdv" scrollable="" persistent="" max-width="400px">
            <v-card color="grey lighten-5" >
              <v-card-title primary-title>
          <div>
            <div class="headline">KDV Düzenle</div>
            <span class="grey--text">Seçili Tarih ve Sonrası İçin KDV Düzenlemesi Yapılacaktır.</span>
          </div>
        </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row="" wrap="">


                  <v-flex xs12 sm12 md12 pa-1>
                    <v-card class="white--text">
                      <v-card color="grey lighten-5" flat="">
                        <v-card-actions>
                          <v-layout row="" wrap="">

                            <v-flex>
                        <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-model="BaslangicTarihi"></tarihcomp>
                      </v-flex>
                         

                          
                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>

                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="Vazgec()">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat @click.native="Onay()" :loading="loading"
      :disabled="loading">{{ $t('Apply') }}</v-btn>
              </v-card-actions>
            </v-card>
          
<snackbarcomp v-bind:mesaj="text1" ref="showMessage" v-model="snackbar"></snackbarcomp>
          </v-dialog>
</template>

<script>
 import auth from '../../../api/auth'
 import helpers from "@/components/app/customcomp/helpers.js"
 import tarihcomp from '../customcomp/tarihim'
 import loadingcomp from "@/components/app/customcomp/loadingcomp"
 import snackbarcomp from "@/components/app/customcomp/snackbarcomp";

 export default {
   props: ["value"],
   components: {
    'tarihcomp': tarihcomp,
    loadingcomp,
    snackbarcomp
   },
   beforeMount: beforeMount,
   

   methods: {
    
    Onay(){
     
        this.loading=true;
        this.KdvDuzenleInput.Tarih1=this.BaslangicTarihi;
        this.KdvDuzenleInput.Tarih2="2223-07-07";
        this.KdvDuzenleInput.SirketNo=this.credentials.SirketKodu;
        this.KdvDuzenleInput.CariDB='';
        var Params = this.KdvDuzenleInput
        this.$http.post(auth.API_URL + 'api/Ticket/BiletKdvDuzenle', Params, {
          headers: auth.getAuthCompaniesInfo()
        }).then((response) => {
          
          this.loading=false;
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service-'
            this.snackbar =true;
            this.loading=false;
          } else {
            this.text1 = this.$t('Edited')
            this.snackbar =true;
            this.loading=false;
          }
        })

    },

     open() {
          this.yardimciIslemKdv = true;
     },
     Vazgec()
     {
      this.yardimciIslemKdv = false;
     },
   
   },
   computed: {
                futureDate() {
                    const futureDate = new Date(this.BaslangicTarihi);
                    futureDate.setDate(futureDate.getDate() + 36500);
                    return futureDate;
                },
            },
   data() {
     return {
      loading: false,
      loadingvmodel: false,
      text1: '',
      snackbar: false,
      loadingmesaj: this.$t('Parent-company-listing'),
      credentials: JSON.parse(window.localStorage.getItem("credentials")),
      KdvDuzenleInput: {
       
          Tarih1: null,
          SirketNo: null,
          Tarih2: null,
          CariDB: null,
         
        },
      yardimciIslemKdv:false,
      BaslangicTarihi:null
     }
   },


   watch: {

   },
 }




 function beforeMount() {

 }
</script>
<style>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>